import React from 'react'
import './footer.css'
import { Button } from '@mui/material'
import { useRef } from 'react';
import emailjs from 'emailjs-com'


const Footer = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm('service_lkkkf1c', 'template_87fkt15', form.current, "CmVko7Y9aW0kR-GvA");

        e.target.reset();
    };




    return (
        <div id='footer'>
            <form ref={form} onSubmit={sendEmail}>

                <div className='form'>
                    <div className='txt-cover'>
                        <label >First Name</label>
                        <input type='text' name='name' required></input>
                    </div>
                    <div className='txt-cover1'>
                        <label >Last Name</label>
                        <input type='text' name='lastname' required></input>
                    </div>
                    <div className='txt-cover2'>
                        <label>E-mail</label>
                        <input type='email' name='email' required></input>
                    </div>
                    <div className='txt-cover3'>
                        <label >Phone Number</label>
                        <input type='tel' name='number' ></input>
                    </div>
                </div>
                <div className='message'>
                    <div className='subj'>
                        <label >Subject</label>
                        <input type='text' name='subject' ></input>
                    </div>
                    <div className='msg'>
                        <label id='msg-txt'>Message</label>
                        <textarea
                            name="message"
                            rows="3"
                            //   value={formData.message}
                            //   onChange={handleChange}
                            required
                        ></textarea>
                    </div>
                </div>
                <button
                    id='btn'
                    type='submit'
                >SUBMIT FORM</button>
            </form>
        </div>
    )
}

export default Footer